import Reveal from "./Reveal";

export default function Chapter({ number, title, subtitle }) {
    return (
        <Reveal className="mb-14 md:mb-20">
            <div className="flex items-end gap-5 md:gap-8">
                <span className="font-display text-lg md:text-xl text-[#FFB800] tracking-widest" data-testid={`chapter-number-${number}`}>
                    {number}
                </span>
                <div className="h-px flex-1 bg-racing-line mb-2" />
                <span className="text-xs uppercase tracking-[0.25em] text-racing-muted mb-1">{subtitle}</span>
            </div>
            <h2 className="mt-6 font-display uppercase text-4xl sm:text-5xl lg:text-6xl leading-none tracking-tight text-neutral-900">
                {title}
            </h2>
        </Reveal>
    );
}
